/**
 * @generated SignedSource<<0b156805432db97cd55cb6f5abbebd4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlogPostItem_BlogPost$data = {
  readonly blogCategories: ReadonlyArray<{
    readonly name: string | null | undefined;
    readonly slug: string | null | undefined;
  }> | null | undefined;
  readonly createdAt: string | null | undefined;
  readonly estimatedReadingTimeMinutes: number | null | undefined;
  readonly excerpt: string | null | undefined;
  readonly slug: string | null | undefined;
  readonly title: string | null | undefined;
  readonly user: {
    readonly name: string | null | undefined;
    readonly profile: {
      readonly slug: string | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"UserAvatarContainer_User">;
  } | null | undefined;
  readonly viewsCount: number | null | undefined;
  readonly " $fragmentType": "BlogPostItem_BlogPost";
};
export type BlogPostItem_BlogPost$key = {
  readonly " $data"?: BlogPostItem_BlogPost$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogPostItem_BlogPost">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogPostItem_BlogPost",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "excerpt",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "BlogCategory",
      "kind": "LinkedField",
      "name": "blogCategories",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimatedReadingTimeMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewsCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserAvatarContainer_User"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BlogPost",
  "abstractKey": null
};
})();

(node as any).hash = "dfc42d69646ca9c53af54d758b429898";

export default node;
